import styled from 'styled-components';
import theme from '@/styles/theme';
import media from '@/styles/media';

/** auth 페이지 제목 역할 */
export const Title = styled.div`
  font-family: ${theme.fontFamily.extraBold};
  font-size: 30px;
  line-height: 34px;
  padding-bottom: 45px;
  max-width: 420px;
  width: 100%;
  ${media.lg`
    font-family: ${theme.fontFamily.bold};
    font-size: 26px;
  `}
  ${media.xs`
    padding: 0 0 30px 25px;
  `}
  &.signup {
    ${media.lg`
      padding-left: 0;
      text-align: center;
    `}
  }
`;

/** 다른 페이지로 이동하는 텍스트 */
export const TextLink = styled.div`
  font-family:  ${theme.fontFamily.regular};
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  text-decoration-line: underline;
  color: ${theme.color.purple};
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
  ${media.lg`
    font-family: ${theme.fontFamily.semiBold};
  `}
`;
